import {RECEIVE_ACTIVE_JOBS_TABLE_COLUMNS} from 'src/action-creators/discover/active-jobs.ts';
import type {ActiveJobsFilterColumnsData} from 'src/types/discover.ts';
import type {DiscoverActiveJobsActions} from 'src/action-creators/discover/active-jobs.ts';


export type ActiveJobsFilterState = {
  activeJobsTableColumnFilter: ActiveJobsFilterColumnsData | null;
};

const initialState: ActiveJobsFilterState = {
  activeJobsTableColumnFilter: null,
};

export default (
  state: ActiveJobsFilterState = initialState,
  action: DiscoverActiveJobsActions,
): ActiveJobsFilterState => {
  switch (action.type) {
    case RECEIVE_ACTIVE_JOBS_TABLE_COLUMNS: {
      return {
        ...state,
        activeJobsTableColumnFilter: action.payload,
      };
    }
  }
  return state;
};
